module.exports = __webpack_public_path__ + "img/tulilla.5162daea.jpeg";